'use client';
import ListPage from '@/components/page-components/list-page/list-page';
import { createListCardArray } from '@/helpers/list-page/list-page-helpers';
import useGetMobileAppWebViewHeader from '@/hooks/use-get-mobile-app-web-view';
import { IMeetingplacePageHomeMinifiedExtendedLogo } from '@/lib/fragments/meetingPlacePageHome-minified';
import { IMeetingPlacePageServiceList } from '@/lib/fragments/meetingPlacePageServiceList';
import { useTenantConfig } from '@/providers/ConfigProvider';

interface MeetingPlacePageTenantListProps {
  contentfulMeetingPlacePageServiceList: IMeetingPlacePageServiceList;
  contentfulMeetingPlacePageHome: IMeetingplacePageHomeMinifiedExtendedLogo;
}
const MeetingPlacePageServiceList = ({
  metaData,
  node_locale,
  urlSubdirectory,
  preview,
  data,
  initialPage,
}: any) => {
  const config = useTenantConfig();
  const prefix = config?.GATSBY_SITE_PATH_PREFIX || '';

  const page = data?.meetingPlacePageServiceList;
  const homepage = data?.meetingPlacePageHomeCollection;

  const services = page?.servicesCollection?.items?.filter(Boolean) ?? [];

  const serviceCardList = createListCardArray(
    services,
    undefined,
    undefined,
    urlSubdirectory,
    node_locale || page?.sys?.locale,
    prefix,
  );

  const isWebView = useGetMobileAppWebViewHeader();

  return (
    <>
      <ListPage
        cardList={serviceCardList}
        pageName={page?.name}
        pageSlug={page?.slug}
        node_locale={node_locale}
        // location={location}
        breadcrumbs={[page?.name]}
        homeText={homepage?.breadcrumbHomeText ?? ''}
        tileColClass="grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
        listType="service"
        isWebView={isWebView}
        initialPage={initialPage ?? 1}
      />
    </>
  );
};

export default MeetingPlacePageServiceList;
